// @mui
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// assets
import { MaintenanceIllustration } from 'src/assets/illustrations';

// ----------------------------------------------------------------------

export default function ErrorView({ resetErrorBoundary }) {
  return (
    <Stack sx={{ alignItems: 'center' }} width="100%">
      <Typography variant="h3" sx={{ mb: 2 }}>
        Something went wrong
      </Typography>

      <Typography sx={{ color: 'text.secondary' }}>
        We are currently working <strong>HARD</strong> on this page!
        <br /> Please come back later or try{' '}
        <Button
          variant="outlined"
          onClick={() => {
            localStorage.clear();
            window.location.href = '/';
          }}
          color="error"
          sx={{ mt: 1, ml: 1 }}
        >
          Logout
        </Button>
        <br />
        and Login again!
      </Typography>

      <MaintenanceIllustration sx={{ my: 5, height: 240 }} />

      <Stack direction="row" spacing={1.5}>
        <Button
          size="large"
          variant="outlined"
          onClick={() => {
            window.location.href = '/';
          }}
        >
          Home
        </Button>
        <Button size="large" variant="contained" onClick={resetErrorBoundary}>
          Retry
        </Button>
      </Stack>
    </Stack>
  );
}
